export const TOPIC_PARTIAL_PATHS: Record<number, string> = {
    16: "dokument",
    40: "revisormal",
};

export const LEGACY_PARTIAL_PATHS = ["revisjonsberetning", "erklaering"];

export const LEGACY_PATHS = [
    "kostra-art",
    "kostra-funksjon",
    "revisjonsprogram",
    "prosess",
    "sjekkliste",
    "dokumentpakke",
    "kalkulator",
    "skjema",
    "regnskap-noter",
    "revisjonsberetning",
    "erklaering",
    "rettsavgjoerelse",
    "vedtak",
    ...LEGACY_PARTIAL_PATHS,
];

export const TOPIC_TYPE_PATHS = {
    15: "praktika",
    30: "art",
    31: "funksjon",
    32: "direktiv",
    33: "qna",
    29: "tema",
    68: "faglitteratur",
    99: "lignings-abc",
    6: "kontoplan",
    47: "sjekkliste-maler",
    17: "regneark-regnskap",
    5: "haandbok",
    2: "lov",
    11: "standard",
    3: "forskrift",
    25: "lovkommentar",
    8: "artikkel-uttalelse",
    4: "forarbeid",
    10: "skatteavtale",
    14: "avgjoerelse",
    45: "nyhet",
    1001: "portal",
    1002: "portal",
    1003: "portal",
    ...TOPIC_PARTIAL_PATHS,
} as const;

export const TOPIC_TYPE_LABELS: Record<string, string> = {
    15: "Praktika",
    29: "Tema",
    30: "Artikkel",
    31: "Funksjon",
    32: "Direktiv",
    33: "Spørsmål og svar",
    68: "Faglitteratur",
    99: "Lignings-ABC",
    6: "Kontoplan",
    47: "Sjekkliste/mal",
    17: "Regneark",
    5: "Håndbok",
    2: "Lov",
    11: "Standard",
    3: "Forskrift",
    25: "Lovkommentar",
    8: "Artikkel/uttalelse",
    4: "Forarbeid",
    10: "Skatteavtale",
    14: "Avgjørelse",
    45: "Nyhet",
};

const PATHS = {
    ROOT: "/",
    FILE: "file",
    NOT_IMPLEMENTED: "ikke-implementert",
};

export const ALL_TOPIC_TYPES = new Set(
    (Object.values(TOPIC_TYPE_PATHS) as string[]).concat(LEGACY_PATHS)
);

export const ALL_PARTIAL_TYPES = new Set(
    Object.values(TOPIC_PARTIAL_PATHS).concat(LEGACY_PARTIAL_PATHS)
);

export default {
    ...PATHS,
    ...TOPIC_TYPE_PATHS,
};
